import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.label`
  ${({ theme }) => css`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 29px;
    letter-spacing: 0.02em;
    color: #000000;

    &:hover {
      border: 1px solid ${theme?.colour?.primary};
    }

  `}
`;

export default Atom({ type: 'label', dataType: 'string', template: template })
